import { ContentRendererExternalQuery } from '@confluence/content-body/entry-points/ContentRendererExternalQuery.graphql.ts';
import type {
	ContentRendererExternalQueryType,
	ContentRendererExternalQueryVariablesType,
} from '@confluence/content-body/entry-points/ContentRendererExternalQuery.ts';
import { preloadContentTitleWithByLineExternal } from '@confluence/content-header/entry-points/preloadContentTitleWithByLineExternal.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';

import SharedContentQuery from './__generated__/SharedContentQuery.graphql.ts';
import type {
	SharedContentQuery as SharedContentQueryType,
	SharedContentQueryVariables,
} from './__types__/SharedContentQuery.ts';

export const preloadExternalShare = async ({ shareToken, contentId }: PreloadExternalShareArgs) => {
	const sharedContentResult = await query<SharedContentQueryType, SharedContentQueryVariables>({
		query: SharedContentQuery,
		variables: {
			shareToken,
			contentId,
		},
		context: {
			allowOnExternalPage: true,
		},
	});

	const singleContent = sharedContentResult?.data?.singleContent;
	const resolvedContentId = contentId ?? singleContent?.id;
	const isPage = singleContent?.type === 'page';

	if (!resolvedContentId || !isPage) {
		return waitForAllReturnWhenError([Promise.resolve(sharedContentResult)]);
	}

	return waitForAllReturnWhenError([
		Promise.resolve(sharedContentResult),
		query<ContentRendererExternalQueryType, ContentRendererExternalQueryVariablesType>({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: ContentRendererExternalQuery,
			variables: {
				contentId: resolvedContentId,
			},
			context: {
				allowOnExternalPage: true,
			},
		}),
		preloadContentTitleWithByLineExternal(resolvedContentId),
	]);
};

type PreloadExternalShareArgs = {
	shareToken: string;
	contentId?: string;
};
